import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useFirestoreConnect } from "react-redux-firebase";
import moment from "moment";
import config from "../../config/common";
import SpotDataListItem from "./SpotDataListItem/index";
import SpotDataList from "./SpotDataList";
import PageTitle from "../../components/PageTitle";
import Header from "../../components/Header";
import SubTitle from "../../components/SubTitle";
import Alert from "../../components/Alert";

const SpotContainer = (props) => {
  const { spotName } = props;
  useFirestoreConnect([
    {
      collection: "buoys",
      doc: spotName,
    },
  ]);
  const spot = useSelector(
    ({ firestore: { data } }) => data.buoys && data.buoys[spotName]
  );

  const Subtitle = () => {
    if (!spot || !spot.buoyData[0]) {
      return null;
    }

    const { date } = spot.buoyData[0];
    return (
      <SubTitle>
        <time dateTime={date}>
          {moment(date)
            .add(config.timeCorrection, "hours")
            .format("ddd, DD, MMM")}
        </time>
      </SubTitle>
    );
  };

  return (
    <>
      <Header>
        <PageTitle>{spotName}</PageTitle>
        <Subtitle />
      </Header>

      {spot && spot.buoyData ? (
        <>
          {!spot.buoyData[0] && <Alert>Buoy Offline</Alert>}
          <SpotDataList>
            {spot &&
              spot.buoyData &&
              spot.buoyData.map((item) => (
                <SpotDataListItem
                  spotName={spotName}
                  key={item.date}
                  date={item.date}
                  height={item.height}
                  peakPeriod={item.peakPeriod}
                  direction={item.direction}
                />
              ))}
          </SpotDataList>
        </>
      ) : (
        <div>Loading</div>
      )}
    </>
  );
};

SpotContainer.propTypes = {
  spotName: PropTypes.string.isRequired,
};

SpotContainer.defaultProps = {
  children: undefined,
};

export default SpotContainer;
